// ── 미팅지도 헤더 ────────────────────────────────────────────────────────────
//   제목 · 피드백 미입력 뱃지 · 마커 배치 초기화 · 글자 크게 · 지도/목록 토글.
//
//   MeetingMap.jsx 가 277줄이라 글자 크게 버튼을 거기 직접 넣으면 300줄 규칙을 넘겼다.
//   헤더 블록을 그대로 옮기고 버튼 하나를 더했다 (2026-09-11).

import React from 'react';
import { TXT } from '../../../components/meetingmap/utils';
import {
  headerStyle, titleStyle, toggleWrapStyle, toggleBtnStyle,
  pendingBadgeBtnStyle, pendingBellIconStyle, pendingCountBadgeStyle,
} from '../../../components/meetingmap/styles';

export function MeetingMapHeader({
  view, setView,
  pendingList, onPendingOpen,
  onResetMarkerLayout,
  textSize, onToggleTextSize,
}) {
  const bigText = textSize === 'large';
  return (
    <div style={headerStyle}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <strong style={titleStyle}>{TXT.title}</strong>
        {/* 피드백 미입력 뱃지 버튼 */}
        <button
          type="button"
          style={pendingBadgeBtnStyle}
          onClick={onPendingOpen}
          title="피드백 미입력 미팅 보기"
        >
          <span style={pendingBellIconStyle}>🔔</span>
          {pendingList.length > 0 && (
            <span style={pendingCountBadgeStyle}>
              {pendingList.length > 99 ? '99+' : pendingList.length}
            </span>
          )}
        </button>
        {/* 마커 배치 초기화 — 옮긴 마커를 원래 위치로 (저장된 배치 삭제) */}
        {view === 'map' && (
          <button
            type="button"
            style={pendingBadgeBtnStyle}
            onClick={onResetMarkerLayout}
            title="옮긴 마커를 원래 위치로 초기화"
          >
            <span style={pendingBellIconStyle}>↺</span>
          </button>
        )}
        {/* 글자 크게 보기 — 목록에서만 의미가 있어 목록 탭일 때만 보인다 (2026-09-11) */}
        {view === 'list' && (
          <button
            type="button"
            style={{
              ...pendingBadgeBtnStyle,
              borderColor: bigText ? 'var(--mm-tone-amber-border)' : undefined,
              background: bigText ? 'var(--mm-tone-amber-bg)' : undefined,
              color: bigText ? 'var(--mm-tone-amber-text)' : undefined,
            }}
            onClick={onToggleTextSize}
            title={bigText ? '글자 크기를 원래대로' : '글자 크게 보기'}
            aria-pressed={bigText}
          >
            <span style={{ ...pendingBellIconStyle, fontWeight: 800 }}>{bigText ? '가⁺' : '가'}</span>
          </button>
        )}
      </div>
      <div style={toggleWrapStyle}>
        <button type="button" style={toggleBtnStyle(view === 'map')} onClick={() => setView('map')}>{TXT.map}</button>
        <button type="button" style={toggleBtnStyle(view === 'list')} onClick={() => setView('list')}>{TXT.list}</button>
      </div>
    </div>
  );
}
